export type ReportColumn = {
  key: string;
  label: string;
  required: boolean;
  defaultSelected: boolean;
};

const mandatoryColumns: ReportColumn[] = [
  { key: 'phoneNumber', label: 'Phone Number', required: true, defaultSelected: true },
  { key: 'startDate', label: 'Start Date', required: true, defaultSelected: true },
  { key: 'endDate', label: 'End Date', required: true, defaultSelected: true },
  { key: 'status', label: 'Status', required: true, defaultSelected: true },
  { key: 'endReason', label: 'End Reason', required: true, defaultSelected: true },
];

export const REPORT_COLUMN_ANALYSIS_SUMMARY_KEY = 'analysisSummary';

export const REPORT_COLUMN_SEPARATE_ANALYSIS_SUMMARY_LABEL = 'Separate Analysis Summary';

const optionalColumns: ReportColumn[] = [
  { key: 'callId', label: 'Call ID', required: false, defaultSelected: true },
  { key: 'callDuration', label: 'Call Duration', required: false, defaultSelected: true },
  { key: 'retries', label: 'Retries', required: false, defaultSelected: true },
  { key: 'whatsappFollowUp', label: 'WhatsApp Follow-up', required: false, defaultSelected: true },
  { key: 'whatsappDelivered', label: 'WhatsApp Delivered', required: false, defaultSelected: true },
  {
    key: 'generateWhatsappMessage',
    label: 'Generate WhatsApp Message',
    required: false,
    defaultSelected: true,
  },
  {
    key: 'generatedWhatsappMessageDelivered',
    label: 'Generated WhatsApp Message Delivered',
    required: false,
    defaultSelected: true,
  },
  {
    key: 'agentNameAndAccent',
    label: 'Agent Name and Accent',
    required: false,
    defaultSelected: true,
  },
  { key: 'sentiments', label: 'Sentiments', required: false, defaultSelected: true },
  { key: 'campaignName', label: 'Campaign Name', required: false, defaultSelected: true },
  { key: 'campaignId', label: 'Campaign ID', required: false, defaultSelected: true },
  {
    key: REPORT_COLUMN_ANALYSIS_SUMMARY_KEY,
    label: 'Analysis Summary',
    required: false,
    defaultSelected: true,
  },
  {
    key: 'analysisDetailedSummary',
    label: 'Analysis Detailed Summary',
    required: false,
    defaultSelected: true,
  },
  { key: 'parentCallId', label: 'Parent Call ID', required: false, defaultSelected: true },
  { key: 'recordingUrl', label: 'Recording URL', required: false, defaultSelected: true },
  { key: 'transcriptUrl', label: 'Transcript URL', required: false, defaultSelected: true },
];

export const REPORT_COLUMNS = [...mandatoryColumns, ...optionalColumns] as const;

export const REPORT_COLUMNS_STORAGE_KEY = 'selectedAdditionalColumns';
